<script>
import { parseHtmlToElements } from '@/utils'

export default {
  functional: true,
  props: {
    html: {
      type: String,
      required: true
    }
  },
  render(createElement, context) {
    const { html } = context.props
    var element = parseHtmlToElements(html)[0]
    return createElement(element.nodeName, {
      // 'class': element.getAttribute('class'),
      // style: element.getAttribute('style')
    }, context.slots().default)
  }
}
</script>
